import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FeaturedArticles } from '../components/FeaturedArticles';
import { CategorySection } from '../components/CategorySection';
import { TrustSection } from '../components/TrustSection';
import { Newsletter } from '../components/Newsletter';
export function HomePage() {
  return <>
      <HeroSection data-id="element-436" />
      <FeaturedArticles limit={3} showViewAll={true} data-id="element-437" />
      <CategorySection data-id="element-438" />
      <TrustSection data-id="element-439" />
      <Newsletter data-id="element-440" />
    </>;
}